import { render, staticRenderFns } from "./TopluGenelTalepDuzenleForm.vue?vue&type=template&id=916de8a8"
import script from "./TopluGenelTalepDuzenleForm.vue?vue&type=script&lang=ts"
export * from "./TopluGenelTalepDuzenleForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports